var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCadent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "b",
    "data-name": "Layer 2",
    viewBox: "0 0 686.56 126.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n  .d {\n    fill: 1b1b1b1b;\n  },\n\n  .e {\n    fill: 20e8f0;\n  }\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M189.89,61.88c0-28.88,20.91-45.43,47.92-45.43,13.82,0,24.52,4.23,32.24,9.58l-12.45,20.29c-5.97-4.11-11.45-6.6-19.05-6.6-12.82,0-23.78,7.72-23.78,22.16s10.95,22.16,23.78,22.16c7.59,0,13.07-2.49,19.05-6.6l12.45,20.29c-7.72,5.35-18.42,9.58-32.24,9.58-27.01,0-47.92-16.56-47.92-45.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M335.88,89.14h-30.15l-5.43,16.53h-26.18l33.96-87.73h25.44l33.96,87.73h-26.18l-5.43-16.53Zm-6.18-19.07l-8.84-27.26-8.96,27.26h17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M451.49,61.8c0,27.32-18.3,43.86-47.75,43.86h-29.95V17.94h29.95c29.7,0,47.75,16.54,47.75,43.86Zm-53.54-22.25v44.5h6.18c13.35,0,22.25-7.42,22.25-22.25s-8.9-22.25-22.25-22.25h-6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M517.46,84.05v21.61h-57.21V17.94h55.94v21.61h-31.79v11.44h26.7v20.34h-27.97v12.71h34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M610.27,105.67h-19.77l-39.75-47.04h-.24v47.04h-22.89V17.94h18.42l41.08,47.04h.25V17.94h22.89V105.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    d: "M686.56,39.55h-22.89V105.67h-22.89V39.55h-21.61V17.94h67.38v21.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#20e8f0",
    d: "M6.56,113.77c1.62,4.05,4.85,6.26,9.68,7.48,3.18,.8,14.44,3.06,36.56,4.16L156.13,20.95c-.88-3.88-1.72-6.54-2.23-7.99-1.45-4.09-5.11-7.04-9.96-8.17-2.96-.69-10.7-1.88-17.67-2.57-6.53-.64-21.76-1.56-28.7-1.73L2.08,98.23c.38,4.01,3.91,14.11,4.48,15.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#20e8f0",
    d: "M80.09,0C39.5,0,20.53,3.71,16.24,4.79c-4.83,1.21-8.51,4.08-9.96,8.17C4.68,17.51,0,33.46,0,62.3c0,8.11,.38,15.85,.94,22.03L84.54,.02c-1.46-.01-2.93-.02-4.45-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#20e8f0",
    d: "M77.46,126.05c30.85,.98,56.79-3.03,64.89-4.34,4.7-.76,9.65-3.66,11.57-8.78,1.75-4.66,6.05-20.5,6.28-49.34,.07-8.11-.92-24.1-1.8-29.91L65.45,126.2c1.46,.01,10.49-.2,12.01-.15Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadent);
export default __webpack_public_path__ + "static/media/cadent.4ce504f188b867a6abe76bf77b32807d.svg";
export { ForwardRef as ReactComponent };